// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7337) return "static/chunks/ad2866b8-d29eef21901316b3.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"2505":"164f4fb6","3632":"b645e135","8445":"bc98253f"}[chunkId] || chunkId) + "." + {"1154":"23996d642e435d03","2505":"14f1d981c2b9ded7","3632":"e82d5a3db0c2a9ec","4444":"f4f41c0ea6c45b18","5243":"983749e6706fbce4","5566":"ea590d028491258b","6466":"b0ef9a2b210d5d48","8445":"f7ce5083a87527fa"}[chunkId] + ".js";
};